import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { WPSiteManagerApiService } from '@vendasta/wp-cloud-manager';

@Injectable({ providedIn: 'root' })
export class WpCloudHostedService {
  private readonly siteManager = inject(WPSiteManagerApiService);
  private readonly resolved = new Map<string, boolean>();
  private readonly inFlight = new Map<string, Observable<boolean>>();

  isHostedOnWpCloud$(agid: string): Observable<boolean> {
    if (!agid) return of(false);
    if (this.resolved.has(agid)) return of(this.resolved.get(agid) as boolean);
    const existing = this.inFlight.get(agid);
    if (existing) return existing;

    const result$ = this.siteManager.getWpSite({ agid }).pipe(
      map((res) => (res?.wpSites ?? []).length > 0),
      tap((value) => {
        this.resolved.set(agid, value);
        this.inFlight.delete(agid);
      }),
      catchError(() => {
        this.inFlight.delete(agid);
        return of(false);
      }),
      shareReplay({ refCount: true, bufferSize: 1 }),
    );
    this.inFlight.set(agid, result$);
    return result$;
  }
}
